import { render, staticRenderFns } from "./Deselected.vue?vue&type=template&id=3f037a34"
import script from "./Deselected.vue?vue&type=script&lang=js"
export * from "./Deselected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports